import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { environment } from '@base/environments/environment';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import {
  RankingOffice,
  RankingOfficeRegion,
} from 'src/app/models/ranking-office.model';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-qr-ranking-item',
  templateUrl: './qr-ranking-item.component.html',
  styleUrls: ['./qr-ranking-item.component.scss'],
})
export class QrRankingItemComponent {
  @Input() isExpandActive: boolean | undefined;
  @Input() isFilterOpen: boolean | undefined;
  @Input() data: RankingOffice | undefined;
  @Input() index: any;
  @Output() viewAverages: EventEmitter<RankingOffice> =
    new EventEmitter<RankingOffice>();
  @Input() userOffices: string[] | undefined;
  @Input() regionsList: RankingOfficeRegion[] | undefined;

  buttonExpand: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.EXPAND_MORE,
    iconOnly: true,
  };
  expand = false;
  filterOpen = false;

  isProd = environment.production;

  buttonAverages: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Promedios',
    icon: Constants.ICONS.TABLE_CHART,
  };

  buttonAveragesOnlyIcon: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.TABLE_CHART,
    iconOnly: true,
  };

  readonly NODE = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_EC = Constants.TENANT_ID_EC;
  readonly NODE_PY = Constants.TENANT_ID_PY;

  constructor(private readonly utils: UtilsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    // expandir/contraer todos los items
    if (this.isExpandActive != null) {
      this.expand = this.isExpandActive;
      this.buttonExpand.icon = this.expand ? 'expand-less' : 'expand-more';
    }

    if (this.isFilterOpen != undefined) {
      this.filterOpen = this.isFilterOpen;
    }
  }

  onClickExpand() {
    this.isExpandActive = undefined;
    this.expand = !this.expand;
    this.buttonExpand.icon = this.expand ? 'expand-less' : 'expand-more';
  }
  
  formatNumberDot(num: number | string): string {
    return this.utils.processNumberAddDotFormat(Number(num));
  }

  averages(): void {
    this.viewAverages.emit(this.data);
  }

  isBlockVisible(block: number): boolean {
    const OFFICE_NORMALIZED: string[] = [];
    this.userOffices?.forEach((office: string) => {
      OFFICE_NORMALIZED.push(this.utils.textNormalize(office));
    });
    const NAME_NORMALIZED = this.utils.textNormalize(this.data?.name);
    const isMyAgency = OFFICE_NORMALIZED.includes(NAME_NORMALIZED);
    let isVisible = false;
    if (block == 3) {
      isVisible = isMyAgency;
    } else if (block == 4) {
      isVisible =
        isMyAgency && this.NODE != this.NODE_EC && this.NODE != this.NODE_PY;
    }

    return isVisible;
  }

  printRegion() {
    const result = this.regionsList?.find(
      (e) => e.regionId == this.data?.region
    );
    return result?.region ?? '-';
  }
}
